// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlansTestimonials_wrapper__SEKwO","button-wrapper":"PlansTestimonials_button-wrapper__2VXf2"};